import { useMemo } from 'react';
import { useLiveData } from 'hooks';
import { ALL_CATEGORIES_QUERY } from 'app-constants/categories';

import { Splash } from '../../../../shared/Components';
import { Box } from '../../../../shared/Typhography';

import { CollectionTable } from './Shared';

const CollectionsScreen = () => {
  const { docs: collections, state } = useLiveData(ALL_CATEGORIES_QUERY);

  const data = useMemo(() => {
    return collections.map((item: any) => {
      const itemData = item.data();

      return {
        firebaseId: item.id,
        id: itemData.id,
        name: itemData.name,
        keywords: itemData.keywords,
        puzzles: itemData.numberOfPuzzles,
        // TODO: remove the "|| ['artist', 'player']" part when all collections have the 'accessibleToRoles' field
        accessibleToRoles: itemData.accessibleToRoles || ['artist', 'player'],
        isAdminOnly: itemData.isAdminOnly,
      };
    });
  }, [collections]);

  if (state === 'loading') {
    return <Splash />;
  }

  return (
    <Box margin="150px auto">
      <h1>Puzzle Categories</h1>
      <CollectionTable data={data} />
    </Box>
  );
};

export default CollectionsScreen;
